import { getSearchParam } from "@/utils";

export default function usePrefix() {
  const { lan } = useLanguage();
  const prefix = getSearchParam("prefix") ?? lan;
  return { prefix };
}
